module.exports = __webpack_public_path__ + "img/logo.35fe5839.png";